const {
  runObjectExtender: baseRunObjectExtender
} = require('vue-js-extender');

exports.runObjectExtender = (Vue) => {
  baseRunObjectExtender(Vue);

  //------------------------- Object Extensions -------------------------
  Object.toCurrency = Object.toCurrency || function (value, currencyType, digits, emptyString, showPrefix = false) {
    if (!!emptyString && !value) {
      return emptyString;
    }

    if (Object.typeOf(value) !== "number") {
      return value;
    }

    if (isNaN(value)) {
      value = 0;
    }

    if ((value > 0 && value < 0.00001) || (value < 0 && value > -0.00001)){
      value = 0;
    }

    if (Object.typeOf(digits) !== "number") {
      digits = 0;
    }

    let locale, currency;
    switch (currencyType) {
      case 1:
        locale = "zh-CN";
        currency = "CNY";
        break;
      case 2:
        locale = "en-CA";
        currency = "CAD";
        break;
      default:
        locale = "en-US";
        currency = "USD";
        break;
    }

    let formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: digits
    });
    let valueText = formatter.format(value);
    if (currencyType === 1)
      valueText = valueText.replace("¥", "￥");

    let prefix = String.empty;
    if (showPrefix) {
      switch (currencyType) {
        case 2:
          prefix = "C";
          break;
      }
      valueText = `${prefix}${valueText}`;
    }

    return valueText;
  };

  Object.toPercent = Object.toPercent || function (value, emptyString) {
    if (!!emptyString && !value) {
      return emptyString;
    }

    if (Object.typeOf(value) !== "number") {
      return value;
    }

    if (isNaN(value)) {
      value = 0;
    }

    var formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 0
    });
    return formatter.format(value);
  }

  Object.toFixedString = Object.toFixedString || function (value, digits) {
    if (Object.typeOf(digits) !== "number") {
      digits = 2;
    }
    let valueTmp = value.toFixed(digits + 1);
    let result = valueTmp.substring(0, valueTmp.lastIndexOf('.') + 3);
    return result;
  };
  //------------------------- End -------------------------
}



// WEBPACK FOOTER //
// ./src/core/js-extender/object.extender.js